import Landing from "src/HomePge/screens/Landing";

export const HomePage = () => {
    return (
        <Landing />
    );
};
export default HomePage;
